import {Page} from './Page.js';

class PageHome extends Page
{
	constructor ()
	{
		console.log('PageHome');
		super();
	}
}

export {PageHome};